<div *ngIf="showLoading" class="flexCenter">
    <mat-spinner></mat-spinner>
</div>

<div *ngIf="!showLoading">

    <app-formular [formBuilderInput]="childFormInput" [formular]="mapFormular" (action)="action($event)"></app-formular>

    <app-grid-template [columns]="columns" [gridData]="outputFormatGridData" (action)="action($event)" [groupName]="'Common'" [title]="'gipContractPrinterList'" enablePaginator="false"></app-grid-template>

    <h4><b>{{"cptn_Map" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "common"}}</b></h4>

    <button mat-raised-button (click)="onSubmit()">{{"RelodMapCommand" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "common"}}</button>

    <form>
        <br>
        <app-map></app-map>
    </form>
    <br>
    <div>
        <button mat-raised-button matStepperPrevious>{{"btn_back" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
        <button mat-raised-button (click)="mapValidator()">{{"Next" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
        <button mat-raised-button *ngIf="routerString == '/gipReqMan'" (click)="close()" style="float: right;">{{"btn_close" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</button>
    </div>
</div>